import { get } from './http';

const baseUrl = process.env.VUE_APP_BASE_URL;

const getToken = (params) => get(`${baseUrl}/guest/createToken`, params);

export default {
  getToken,
}
